import { addEvent } from '../addEvent/addEvent';

export function lazyLoadImage(images) {
  const imgOption = { rootMargin: '30px 0px 75px 0px' };
  const imgObserver = new IntersectionObserver((entries, imgObserver) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        console.log('!entry.isIntersecting');
        return;
      } else {
        console.log({ target: entry.target });
        preloadImage(entry.target);
        entry.target.removeAttribute('[data-images]');
        imgObserver.unobserve(entry.target);
      }
    });
  }, imgOption);

  images.forEach(image => {
    imgObserver.observe(image);
  });
}

async function preloadImage(elm) {
  let picture = elm; //elm.getElementsByTagName("picture")[0];
  let loading =
    elm.parentElement.getElementsByClassName('lazyloading-lading')[0];
  let sources = picture.getElementsByTagName('source');
  let img = picture.getElementsByTagName('img')[0];

  Array.from(sources).forEach(source => {
    source.remove();
  });

  if (!img) return;

  const dataImages = elm.dataset.images;
  const imagesArray = dataImages.split('%');
  const datasrctype = elm.dataset.srctype;
  const sizes = elm.dataset.sizes;
  /*const datasrc = elm.dataset.src;
  const datasrcx2 = elm.dataset.srcx2;
  const datasrcwebp = elm.dataset.srcwebp;
  const datasrcwebpx2 = elm.dataset.srcwebpx2;
  */

  try {
    const sendData = new FormData();

    Array.from(imagesArray).forEach((image, idx) => {
      image != '' ? sendData.append('url-' + idx, image) : false;
    });

    /*
    sendData.append("url", datasrc);
    sendData.append("urlx2", datasrcx2);
    sendData.append("urlwebp", datasrcwebp);
    sendData.append("urlwebpx2", datasrcwebpx2);
    */

    const request = await fetch('/lazyimages/lazy', {
      method: 'post',
      mode: 'cors',
      body: sendData,
    });

    if (request.ok) {
      const data = await request.json();

      img.removeAttribute('height');
      img.removeAttribute('width');

      if (data.status === true && data.data !== false) {
        Array.from(data.data).forEach((image, idx) => {
          let source = document.createElement('SOURCE');
          source.type = image.mime;
          //source.sizes = sizes;
          source.srcset = `${image['srcset']}`;
          picture.prepend(source);

          if (idx == 0) {
            img.src = image.src;
            img.srcset = image.srcset;
            img.type = image.mime;
            img.width = image['0'];
            img.height = image['1'];
            img.sizes = sizes;
          }
        });

        if (loading) {
          addEvent(img, 'load', function () {
            loading.remove();
          });
        }
      }
    }
  } catch (err) {
    console.log(err);
    img.src = imagesArray[0];
    img.type = datasrctype;

    if (loading) {
      addEvent(img, 'load', function () {
        loading.remove();
      });
    }
  }
}
